import { Component, OnInit, ViewChild, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgbModal, NgbDropdownConfig, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { EditarAnalistaComponent } from '../../modals/centralizacion-remuneraciones/editar-analista/editar-analista.component';
import { EditarConfirmarComponent } from '../../modals/centralizacion-remuneraciones/editar-confirmar/editar-confirmar.component';
import { SimulacionComponent } from '../../modals/centralizacion-remuneraciones/simulacion/simulacion.component';
import { CentrosProcesoService } from '../../../services/centralization/centrosProceso.service';
import { ComunesService } from '../../../services/centralization/comunes.service';
import { ProcesosService } from '../../../services/centralization/procesos.service';
import { dutchRangeLabel } from '../../../shared/dutchRangeLabel';
import { lastValueFrom } from 'rxjs';
import * as Papa from 'papaparse';

import { AuthorizationService } from '../../../services';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../../shared/pipes';

@Component({
  selector: 'app-process-summary',
  imports: [CommonModule,
    ReactiveFormsModule,
    RouterLink,
    MatTableModule,
    MatPaginatorModule, PipesModule, NgbDropdownModule],
  templateUrl: './process-summary.component.html',
  styleUrl: './process-summary.component.css'
})
export class ProcessSummaryComponent {
  procId: any = null;
  procTipo: any = null;
  proceso: any = null;
  procesoDatosForm: FormGroup;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  @ViewChildren('fileInputEditar') fileInputsEditar!: QueryList<ElementRef>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns: any[] = [
    'centroCodigoCompania',
    'centroNombre',
    'centroAnalistaFzas',
    'centroEstado',
    'centroArchivo',
    'centroSimular',
    'centroProcesar',
    'opciones'
  ];
  pageSize = 5;
  pageSizeOptions = [5, 10, 25, 50];
  totalRows = 0;
  procesoBorrador: boolean = true;
  centroCompletado: boolean = false;
  periodoSelected: string = '';
  UUIDActual: string = '';
  elementList: any[] = [];
  usuarioActual!: any;
  centrosNoProcesados: boolean = true;

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly _modalService: NgbModal,
    private readonly _spinner: NgxSpinnerService,
    private readonly _toastr: ToastrService,
    private readonly _router: Router,
    private readonly _active: ActivatedRoute,
    private readonly _procesosService: ProcesosService,
    private readonly _centrosProcesoService: CentrosProcesoService,
    private readonly _comunesService: ComunesService,
    public AuthorizationService: AuthorizationService,
    config: NgbDropdownConfig
  ) {
    this.procesoDatosForm = this._formBuilder.group({
      procesoNombre: ['', Validators.required],
      procesoPeriodo: ['', Validators.required]
    });
    config.placement = 'bottom-end';
  }

  ngOnInit(): void {
    this._active.params.subscribe(params => {
      this.procId = params['id'];
      this.procTipo = params['type'];
    });

    this.obtenerUsuarioActual();
    const data: any[] = [];
    this.dataSource = new MatTableDataSource(data);
    this.totalRows = this.dataSource.data.length;
    this.visualizarProceso(this.procId, this.procTipo, false);
  }

  ngAfterViewInit() {
    this.paginator._intl.itemsPerPageLabel = 'Filas por página';
    this.paginator._intl.nextPageLabel = 'Página Siguiente';
    this.paginator._intl.previousPageLabel = 'Página Anterior';
    this.paginator._intl.getRangeLabel = dutchRangeLabel;
    this.dataSource.paginator = this.paginator;
  }

  onFileSelected(event: any, centProcId: any, centProcNombre: any) {
    this._spinner.show();
    const file: File = event.target.files[0];

    if (file.type !== 'text/plain') {
      this._spinner.hide();
      this._toastr.warning(
        'Solo se permiten archivos .txt. Seleccione un archivo válido.',
        'Advertencia'
      );
      return;
    }

    let parsedData: any[] = [];
    const fileName = `CentRemuneraciones/${this.proceso.procId}/${file.name}`;
    const fileData = { key: fileName, metodo: 'put', tipo: file?.type }

    Papa.parse(file, {
      skipEmptyLines: true,
      complete: (result) => {
        const rows = result.data as string[][];
        parsedData = rows.map(row => this.convertRowToObject(row));
        console.log(parsedData);
      },
      error: (error) => {
        console.error('Error al procesar el archivo:', error);
      }
    });

    try {
      this._comunesService.getSignedUrl(fileData).subscribe({
        next: (data: any) => {
          console.log(data);
          const url = data.message;
          console.log(url);
          this._comunesService.uploadFileS3(file, url, fileData.tipo).subscribe({
            next: async (data: any) => {
              console.log(data);

              if (data == 'ok') {
                const fileNameDataCSV = await this.uploadJSONDataToS3(fileName, centProcId, centProcNombre, parsedData);
                console.log({ fileNameDataCSV });

              } else {
                this.showUploadError();
              }
            },
            error: (error: any) => {
              console.log(error);
              this.showUploadError();
            }
          })
        },
        error: (error: any) => {
          console.log(error);
          this.showUploadError();
        }
      });

    } catch (error) {
      this.showUploadError();
    }
  }

  onFileSelectedEdit(event: any, centProcId: any, centProcNombre: any) {
    this._spinner.show();
    const file: File = event.target.files[0];

    if (file.type !== 'text/plain') {
      this._spinner.hide();
      this._toastr.warning(
        'Solo se permiten archivos .txt. Seleccione un archivo válido.',
        'Advertencia'
      );
      return;
    }

    let parsedData: any[] = [];
    const fileName = `CentRemuneraciones/${this.proceso.procId}/${file.name}`;
    const fileData = { key: fileName, metodo: 'put', tipo: file?.type }

    Papa.parse(file, {
      skipEmptyLines: true,
      complete: (result) => {
        const rows = result.data as string[][];
        parsedData = rows.map(row => this.convertRowToObject(row));
        console.log(parsedData);
      },
      error: (error) => {
        console.error('Error al procesar el archivo:', error);
      }
    });

    try {
      this._comunesService.getSignedUrl(fileData).subscribe({
        next: (data: any) => {
          console.log(data);
          const url = data.message;
          console.log(url);
          this._comunesService.uploadFileS3(file, url, fileData.tipo).subscribe({
            next: async (data: any) => {
              console.log(data);

              if (data == 'ok') {
                const fileNameDataCSV = await this.uploadJSONDataToS3(fileName, centProcId, centProcNombre, parsedData);
                console.log({ fileNameDataCSV });

              } else {
                this.showUploadError();
              }
            },
            error: (error: any) => {
              console.log(error);
              this.showUploadError();
            }
          })
        },
        error: (error: any) => {
          console.log(error);
          this.showUploadError();
        }
      });

    } catch (error) {
      this.showUploadError();
    }
  }

  uploadJSONDataToS3(fileNameArchivo: any, centProcId: any, centProcNombre: any, jsonData: any): any {
    const jsonString = JSON.stringify(jsonData);
    const fileName = `CentRemuneraciones/${this.proceso.procId}/dataCSV${centProcId}.json`;
    const fileData = { key: fileName, metodo: 'put', tipo: 'application/json' };

    this._comunesService.getSignedUrl(fileData).subscribe({
      next: (data: any) => {
        console.log(data);
        const url = data.message;
        console.log(url);
        const blob = new Blob([jsonString], { type: 'application/json' });
        console.log(blob);

        this._comunesService.uploadFileS3(blob, url, fileData.tipo).subscribe({
          next: (data: any) => {
            console.log(data);
            if (data == 'ok') {
              this.actualizarDocumentoOk(fileNameArchivo, centProcId, centProcNombre, fileName || jsonString);
              return fileName;
            } else {
              return null;
            }
          },
          error: (error: any) => {
            console.log(error);
            this.showUploadError();
            return null;
          }
        })
      },
      error: (error: any) => {
        console.log(error);
        this.showUploadError();
        return null;
      }
    });
  }

  convertRowToObject(row: string[]): any {
    const keys = [
      'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
      'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE'
    ];

    const rowObject: any = {};
    keys.forEach((key, index) => {
      rowObject[key] = row[index] ? row[index].trim() : '';
    });

    return rowObject;
  }

  actualizarDocumentoOk(fileName: any, centProcId: any, centProcNombre: any, centProcDataArchivo: any) {
    let userName = null;
    let userId = null;
    const currentUser = localStorage.getItem('currentUserCr');

    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      userName = parsedUser.us_nombres;
      userId = parsedUser.us_id;
      console.log('userName:', userName);
    }

    const currentDateTime = new Date().toISOString();

    const body = {
      centProcKeyS3DocumentoOk: fileName,
      centProcId: centProcId,
      centProcUpdateAt: currentDateTime,
      userName: userName,
      centProcNombre: centProcNombre,
      procId: this.proceso.procId,
      userId: userId
    }

    this._centrosProcesoService.actualizarDocumentoOk(body).subscribe({
      next: (data: any) => {
        console.log(data);
        this.actualizarDataArchivo(centProcId, centProcDataArchivo, centProcNombre);
      },
      error: (error: any) => {
        this._spinner.hide();
        this._toastr.warning(
          'Ocurrio un problema al intentar subir el archivo. Intentelo más tarde o contacte con Soporte.',
          'Error'
        );
        console.log(error);
      }
    });
  }

  actualizarDataArchivo(centProcId: any, centProcDataArchivo: any, centProcNombre: any) {
    let userName = null;
    const currentUser = localStorage.getItem('currentUserCr');

    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      userName = parsedUser.us_nombres;
    }

    const currentDateTime = new Date().toISOString();

    const body = {
      centProcId: centProcId,
      centProcDataArchivo: centProcDataArchivo,
      centProcUpdateAt: currentDateTime,
      userName: userName,
    }

    this._centrosProcesoService.actualizarDataArchivo(body).subscribe({
      next: async (res: any) => {
        console.log('response:', res);
        this.visualizarProceso(this.procId, this.procTipo, false);
      },
      error: (err: any) => {
        console.log('error:', err);
        this._spinner.hide();
        this._toastr.warning(
          'Ocurrio un problema al intentar subir el archivo. Intentelo más tarde o contacte con Soporte.',
          'Error'
        );
      }
    });
  }

  descargarArchivo(key: any) {
    this._spinner.show();
    try {
      console.log(key);
      const fileData: any = { key, metodo: 'get' };
      this._comunesService.getSignedUrl(fileData).subscribe({
        next: (data: any) => {
          console.log(data);
          const url = data.message;
          const fileName = key.split('/').pop() || 'archivo.txt';

          fetch(url)
            .then(response => response.blob())
            .then(blob => {
              const downloadUrl = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.download = fileName;
              link.click();
              URL.revokeObjectURL(downloadUrl);
            })
            .catch((err) => {
              console.error('Error al descargar el archivo:', err);
              this._toastr.warning(
                'Ocurrió un problema al intentar descargar el archivo. Inténtelo más tarde o contacte con Soporte.',
                'Error'
              );
            });
        },
        error: (error: any) => {
          console.log(error);
          this._toastr.warning(
            'Ocurrió un problema al intentar descargar el archivo. Inténtelo más tarde o contacte con Soporte.',
            'Error'
          );
        }
      });
    } catch (error: any) {
      console.log(error);
    } finally {
      this._spinner.hide();
    }
  }


  abrirModalEditarArchivo(centProcId: any, centProcNombre: any) {
    const modalRef = this._modalService.open(EditarConfirmarComponent, { backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Editar Archivo';
    modalRef.componentInstance.texto = `¿Está seguro de querer editar el archivo del Centro: “${centProcNombre}”?`;

    modalRef.result.then(
      async (result) => {
        console.log('Modal cerrado con resultado:', result);
        if (result) {
          // Encuentra el archivo específico y dispara el click
          const fileInput = this.fileInputsEditar.find((el, index) => {
            return this.elementList[index].centProcId === centProcId;
          });
          if (fileInput) {
            fileInput.nativeElement.click();
          }
        }
      },
      (reason) => {
        console.log('Modal cerrado por:', reason);
      }
    );
  }


  actualizarEstadoCentroProceso(centProcId: any, nuevoEstadoCentProcId: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this._spinner.show();
      let userName = null;
      const currentUser = localStorage.getItem('currentUserCr');

      if (currentUser) {
        const parsedUser = JSON.parse(currentUser);
        userName = parsedUser.us_nombres;
      }

      const currentDateTime = new Date().toISOString();

      const body = {
        estCentroId: nuevoEstadoCentProcId,
        centProcId: centProcId,
        centProcUpdateAt: currentDateTime,
        userName: userName
      };

      this._centrosProcesoService.actualizarEstadoCentroProceso(body).subscribe({
        next: (res: any) => {
          console.log('response:', res);
          resolve();
        },
        error: (err: any) => {
          console.log('error:', err);
          this._spinner.hide();
          reject(err);
        }
      });
    });
  }

  abrirModalEditarAnalista(element: any) {
    console.log(element);
    const modalRef = this._modalService.open(EditarAnalistaComponent, { backdrop: 'static', centered: true });
    modalRef.componentInstance.centroDatos = element;
    modalRef.result.then(
      (result) => {
        console.log('Modal cerrado con resultado:', result);
        if (result) {
          let nuevoAnalistaNombre = result.name;
          let nuevoAnalistaId = result.code;
          const modalRef = this._modalService.open(EditarConfirmarComponent, { backdrop: 'static' });
          modalRef.componentInstance.titulo = 'Editar Analista de Finanzas';
          modalRef.componentInstance.texto = `¿Está seguro de querer editar al Analista de Finanzas para el Centro: “${element.centProcNombre}”?`;
          modalRef.result.then(
            (result) => {
              console.log('Modal cerrado con resultado:', result);
              if (result) {
                this.actualizarAnalistaFinanzas(element.centProcId, element.centProcNombre, nuevoAnalistaNombre, nuevoAnalistaId);
              }
            },
            (reason) => {
              console.log('Modal cerrado por:', reason);
            }
          );
        }
      },
      (reason) => {
        console.log('Modal cerrado por:', reason);
      }
    );
  }

  actualizarAnalistaFinanzas(centProcId: any, centProcNombre: any, nuevoAnalista: any, usId: any) {
    this._spinner.show();
    let userName = null;
    let userId = null;
    const currentUser = localStorage.getItem('currentUserCr');

    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      userName = parsedUser.us_nombres;
      userId = parsedUser.us_id;
      console.log('userName:', userName);
    }

    const currentDateTime = new Date().toISOString();

    const body = {
      centProcAnalistaFinanza: nuevoAnalista,
      centProcId: centProcId,
      usId: usId,
      centProcUpdateAt: currentDateTime,
      userName: userName,
      centProcNombre: centProcNombre,
      procId: this.proceso.procId,
      userId: userId
    }

    this._centrosProcesoService.actualizarAnalistaFinanzas(body).subscribe({
      next: (res: any) => {
        console.log('response:', res);
        this.visualizarProceso(this.procId, this.procTipo);
        this._toastr.success(
          'Analista de Finanzas actualizado correctamente.',
          'Éxito'
        );
      },
      error: (err: any) => {
        console.log('error:', err);
        this._spinner.hide();
        this._toastr.warning(
          'Ocurrio un error al intentar crear un nuevo proceso. Intente más tarde o contacte a Soporte.',
          'Error'
        );
      }
    });
  }

  actualizarSimulacionId(centProcId: any, nuevoEstadoSimId: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this._spinner.show();
      let userName = null;
      const currentUser = localStorage.getItem('currentUserCr');

      if (currentUser) {
        const parsedUser = JSON.parse(currentUser);
        userName = parsedUser.us_nombres;
      }

      const currentDateTime = new Date().toISOString();

      const body = {
        centProcId: centProcId,
        estSimulacionId: nuevoEstadoSimId,
        centProcUpdateAt: currentDateTime,
        userName: userName
      };

      this._centrosProcesoService.actualizarSimulacionId(body).subscribe({
        next: (res: any) => {
          console.log('response:', res);
          if (nuevoEstadoSimId == 2) {
            this.visualizarProceso(this.procId, this.procTipo, false);
            this._spinner.hide();
          }
          resolve();
        },
        error: (err: any) => {
          console.log('error:', err);
          this._spinner.hide();
          reject(err);
        }
      });
    });
  }

  actualizarProcesadoId(centProcId: any, centProcNombre: any, nuevoEstadoProId: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this._spinner.show();
      let userName = null;
      let userId = null;
      const currentUser = localStorage.getItem('currentUserCr');

      if (currentUser) {
        const parsedUser = JSON.parse(currentUser);
        userName = parsedUser.us_nombres;
        userId = parsedUser.us_id;
        console.log('userName:', userName);
      }

      const currentDateTime = new Date().toISOString();

      const body = {
        centProcId: centProcId,
        estProcesadoId: nuevoEstadoProId,
        centProcUpdateAt: currentDateTime,
        userName: userName,
        centProcNombre: centProcNombre,
        procId: this.proceso.procId,
        userId: userId
      };

      this._centrosProcesoService.actualizarProcesadoId(body).subscribe({
        next: (res: any) => {
          console.log('response:', res);
          if (nuevoEstadoProId == 2) {
            this.visualizarProceso(this.procId, this.procTipo);
            this._spinner.hide();
          }
          resolve();
        },
        error: (err: any) => {
          console.log('error:', err);
          this._spinner.hide();
          reject(err);
        }
      });
    });
  }

  guardarProceso() {
    this._spinner.show();
    setTimeout(() => {
      this._router.navigate(['process-list']);
    }, 2000);
  }

  habilitarCerradoProceso() {
    console.log('entro a habilitarCerradoProceso');
    const centrosProceso = this.proceso.centroProceso;
    let procesosIncompletos = 0;

    for (const centro of centrosProceso) {
      if (centro.estCentroId != 2) {
        procesosIncompletos++;
      }
    }

    console.log('procesosIncompletos:', procesosIncompletos);
    this.centrosNoProcesados = procesosIncompletos > 0;
  }

  cerrarProceso() {
    console.log(this.proceso);
    const centrosProceso = this.proceso.centroProceso;
    let procesosIncompletos = 0;

    for (const centro of centrosProceso) {
      if (centro.estCentroId != 2) {
        procesosIncompletos++;
      }
    }

    if (procesosIncompletos > 0) {
      this._toastr.warning(
        'No se puede cerrar el proceso, ya que todos los centros deben estar completamente procesados.',
        'Advertencia'
      );
      return;
    }

    const modalRef = this._modalService.open(EditarConfirmarComponent, { backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Cerrar Proceso';
    modalRef.componentInstance.texto = `¿Está seguro de querer cerrar el Proceso: “${this.proceso.procNombre}”?`;

    modalRef.result.then(
      async (result) => {
        console.log('Modal cerrado con resultado:', result);
        if (result) {
          this._spinner.show();
          let userName = null;
          const currentUser = localStorage.getItem('currentUserCr');

          if (currentUser) {
            const parsedUser = JSON.parse(currentUser);
            userName = parsedUser.us_nombres;
          }

          const currentDateTime = new Date().toISOString();

          const body = {
            procId: this.procId,
            procTipo: this.procTipo,
            centProcUpdateAt: currentDateTime,
            centProcUpdateFor: userName
          };

          this._procesosService.cerrarProceso(body).subscribe({
            next: (data: any) => {
              console.log(data);
              this._toastr.success('Proceso cerrado correctamente.', 'Éxito');
              this._router.navigate(['/private/lista-procesos']);
            },
            error: (error: any) => {
              console.log(error);
              this._spinner.hide();
            }
          });
        }
      },
      (reason) => {
        console.log('Modal cerrado por:', reason);
      }
    );
  }

  simularProcesamiento(centro: any) {
    this._spinner.show();

    const payload = {
      centro: {
        centProcId: centro.centProcId,
        centProcSegmento: centro.centProcSegmento,
        centProcSociedad: centro.centProcSociedad,
        centProcCentroCosto: centro.centProcCentroCosto
      },
      key: centro.centProcKeyS3DocumentoOk
    };

    this._centrosProcesoService.simularProcesamiento(payload).subscribe({
      next: async (res: any) => {
        console.log(res);
        const data = await lastValueFrom(this._centrosProcesoService.actualizarDatosSimulacion(res.datosSimulacion));
        console.log({ data });

        if (!res.datosSimulacion.errores) {
          await this.actualizarSimulacionId(centro.centProcId, res.datosSimulacion.estadoSimulacion);
          await this.actualizarEstadoCentroProceso(centro.centProcId, 1);
          this.visualizarProceso(this.procId, this.procTipo);
          this.abrirModalSimulacion(res.datosSimulacion, false);
        } else {
          await this.actualizarSimulacionId(centro.centProcId, res.datosSimulacion.estadoSimulacion);
          await this.actualizarEstadoCentroProceso(centro.centProcId, 1);
          if (res.base64Data && res.fileName) {
            this.uploadBase64ExcelToS3(res.base64Data, res.fileName, centro.centProcId, centro.centProcNombre);
          } else {
            this.actualizarDocumentoFallo('', centro.centProcId, centro.centProcNombre);
          }
        }
      },
      error: (err: any) => {
        console.log(err);
        this._toastr.warning('Lo sentimos, ocurrio un error al intentar simular el proceso. Contacte con Soporte.', 'Error de simulación');
        this._spinner.hide();
      }
    });
  }

  downloadBase64File(fileName: string, base64Data: string) {
    const link = document.createElement('a');
    link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64Data}`;
    link.download = fileName;
    link.click();
  }

  uploadBase64ExcelToS3(base64Data: string, fileName: string, centProcId: any, centProcNombre: any): void {
    const filePath = `CentRemuneraciones/${this.proceso.procId}/${fileName}.xlsx`;
    const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const fileData = { key: filePath, metodo: 'put', tipo: contentType };
    const base64String = base64Data.includes(',') ? base64Data.split(',')[1] : base64Data;
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blobFile = new Blob([byteArray], { type: contentType });

    this._comunesService.getSignedUrl(fileData).subscribe({
      next: (data: any) => {
        const url = data.message;
        this._comunesService.uploadFileS3(blobFile, url, fileData.tipo).subscribe({
          next: (uploadResponse: any) => {
            if (uploadResponse === 'ok') {
              this.actualizarDocumentoFallo(filePath, centProcId, centProcNombre);
            } else {
              this.showUploadError();
            }
          },
          error: (error: any) => {
            console.log(error);
            this.showUploadError();
          }
        });
      },
      error: (error: any) => {
        console.log(error);
        this.showUploadError();
      }
    });
  }

  actualizarDocumentoFallo(fileName: any, centProcId: any, centProcNombre: any) {
    let userName = null;
    let userId = null;
    const currentUser = localStorage.getItem('currentUserCr');

    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      userName = parsedUser.us_nombres;
      userId = parsedUser.us_id;
      console.log('userName:', userName);
    }

    const currentDateTime = new Date().toISOString();

    const body = {
      centProcKeyS3DocumentoFallo: fileName,
      centProcId: centProcId,
      centProcUpdateAt: currentDateTime,
      userName: userName,
      centProcNombre: centProcNombre,
      procId: this.proceso.procId,
      userId: userId
    }

    this._centrosProcesoService.actualizarDocumentoFallo(body).subscribe({
      next: (res: any) => {
        console.log('response:', res);
        this.visualizarProceso(this.procId, this.procTipo, true, centProcId);
      },
      error: (err: any) => {
        console.log('error:', err);
        this._spinner.hide();
        this._toastr.warning(
          'Ocurrió un problema al intentar persistir el documento de simulacion con errores. Intentelo más tarde o contacte con Soporte.',
          'Error'
        );
      }
    });
  }

  visualizarProceso(procId: any, procTipo: any, isFallaSimulacion?: boolean, centProcIdSimulacion?: any) {
    this._spinner.show();
    this._procesosService.obtenerProcesoById(procId, procTipo).subscribe({
      next: (res: any) => {
        console.log(res);
        this.proceso = res.proceso;
        this.habilitarCerradoProceso();
        this.procesoDatosForm.controls['procesoNombre'].setValue(this.proceso.procNombre);
        this.procesoDatosForm.controls['procesoNombre'].disable();
        this.procesoDatosForm.controls['procesoPeriodo'].setValue(this.proceso.procPeriodo);
        this.procesoDatosForm.controls['procesoPeriodo'].disable();
        this.proceso.centroProceso.forEach((centro: any) => { centro.procPeriodo = this.proceso.procPeriodo; });
        this.elementList = this.proceso.centroProceso;
        this.dataSource = new MatTableDataSource(this.proceso.centroProceso);
        this.totalRows = this.dataSource.data.length;
        this.dataSource.paginator = this.paginator;
        this._spinner.hide();
        if (isFallaSimulacion) {
          console.log(this.proceso.centroProceso);
          console.log(centProcIdSimulacion);
          const centroEnSimulacion = this.proceso.centroProceso.find((centro: any) => { return centro.centProcId === centProcIdSimulacion; });
          console.log(centroEnSimulacion);
          this.abrirModalSimulacion(centroEnSimulacion, true);
        }
      },
      error: (err: any) => {
        this._spinner.hide();
        console.log(err);
        this._toastr.warning(
          'Ocurrió un problema al intentar visualizar el proceso. Intentelo más tarde o contacte con Soporte.',
          'Error'
        );
      }
    });
  }

  abrirModalSimulacion(element: any, error: boolean) {
    const modalRef = this._modalService.open(SimulacionComponent, { backdrop: 'static', centered: true });
    modalRef.componentInstance.datosSimulacion = element;
    modalRef.componentInstance.error = error;
  }

  showUploadError(): void {
    this._spinner.hide();
    this._toastr.warning(
      'Ocurrió un problema al intentar subir el archivo. Intentelo más tarde o contacte con Soporte.',
      'Error'
    );
  }

  obtenerUsuarioActual() {
    const currentUser = localStorage.getItem('currentUserCr');
    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      this.usuarioActual = parsedUser;
    } else {
      this._toastr.warning('Error al obtener el usuario actual.', 'Error');
      this._router.navigate(['/not-authorized']);
    }
  }

  procesarCentro(centroProceso: any) {
    this._spinner.show();
    let userName = null;
    let userId = null;
    const currentUser = localStorage.getItem('currentUserCr');

    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      userName = parsedUser.us_nombres;
      userId = parsedUser.us_id;
      console.log('userName:', userName);
    }
    const currentDateTime = new Date();
    const adjustedDateTime = new Date(currentDateTime.getTime() - 3 * 60 * 60 * 1000).toISOString();
    const procPeriodo = this.transformarPeriodo(this.proceso.procPeriodo);
    console.log('procPeriodo', procPeriodo)
    const centProcCodCompania = centroProceso.centProcCodCompania

    const body = {
      procId: this.procId,
      centProcId: centroProceso.centProcId,
      centProcUpdateAt: adjustedDateTime,
      centProcUpdateFor: userName,
      usId: userId,
      rutaArchivo: centroProceso.centProcKeyS3DocumentoOk,
      DocumentHeaderText: `${centProcCodCompania}-REMUN${procPeriodo}`,
      idCentroPeriodo: `${centProcCodCompania}-${procPeriodo}`,
      CompanyCode: centroProceso.centProcSociedad,
      centProcSegmento: centroProceso.centProcSegmento
    }
    console.log('body', body)

    this._centrosProcesoService.procesarCentro(body).subscribe({
      next: (res: any) => {
        console.log('response:', res);
        this.visualizarProceso(this.procId, this.procTipo);
        this._toastr.success('Centro Procesado Correctamente.', 'Éxito');
        this._spinner.hide();
      },
      error: (err: any) => {
        console.log('error:', err);
        this._spinner.hide();
        this._toastr.warning(
          'Ocurrió un problema al intentar el procesamiento del centro. Intentelo más tarde o contacte con Soporte.',
          'Error'
        );
      }
    });
  }

  abrirModalAnularProcesamiento(centProcId: any, centProcNombre: any) {
    const modalRef = this._modalService.open(EditarConfirmarComponent, { backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Anular Procesamiento';
    modalRef.componentInstance.texto = `¿Está seguro de querer anular el procesamiento del Centro: “${centProcNombre}”?`;
    modalRef.result.then(
      async (result) => {
        console.log('Modal cerrado con resultado:', result);
        if (result) {
          this.anularProcesamiento(centProcId);
        }
      },
      (reason) => {
        console.log('Modal cerrado por:', reason);
      }
    );
  }

  anularProcesamiento(centProcId: any) {
    this._spinner.show();
    let userName = null;
    const currentUser = localStorage.getItem('currentUserCr');

    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      userName = parsedUser.us_nombres;
    }

    const currentDateTime = new Date().toISOString();

    const body = {
      centProcId: centProcId,
      centProcUpdateAt: currentDateTime,
      userName: userName,
    }

    this._centrosProcesoService.anularProcesamientoCentro(body).subscribe({
      next: (res: any) => {
        console.log('response:', res);
        this.visualizarProceso(this.procId, this.procTipo);
      },
      error: (err: any) => {
        console.log('error:', err);
        this._spinner.hide();
        this._toastr.warning(
          'Ocurrió un problema al intentar anular procesamiento. Intentelo más tarde o contacte con Soporte.',
          'Error'
        );
      }
    })
  }

  transformarPeriodo(procPeriodo: string): string {
    const [mesAbrev, anio] = procPeriodo.split('/');

    const meses: { [key: string]: number } = {
      'ENE': 1, 'FEB': 2, 'MAR': 3, 'ABR': 4,
      'MAY': 5, 'JUN': 6, 'JUL': 7, 'AGO': 8,
      'SEP': 9, 'OCT': 10, 'NOV': 11, 'DIC': 12
    };

    const mesNumerico = meses[mesAbrev.toUpperCase()];

    if (!mesNumerico) throw new Error(`Mes no válido: ${mesAbrev}`);

    return `${anio}${mesNumerico.toString().padStart(2, '0')}`;
  }
  cancelar(): void {
    this._router.navigate(['process-list']);
  }

}
